import { Component } from "react";
import './Clients.css';

class Clients extends Component {
    render() {
        return (
            <div className="Clients container-fluid" id="clients">
                <div className="sub-heading">
                    <h3>CLIENTS</h3>
                </div>
                <p className="words">We attribute much of our success to the close professional relationships we enjoy with our clients.</p>
                <p className="words">We aim to do everything we can to create a successful working partnership because we know from experience that this approach gets results.</p>
                <p className="words">ANA IT Solutions Inc. clients comprise of a wide range of organisations, from high profile national and international companies, blue chip companies, to small local enterprises.</p>
                <p className="words">We cater to clients from the following industries:</p>
                <ul>
                    <li><p>Electronic parts suppliers</p></li>
                    <li><p>Computer manufacturers</p></li>
                    <li><p>Logistics</p></li>
                    <li><p>Shipping</p></li>
                    <li><p>Healthcare</p></li>                    
                </ul>
            </div>
        )
    }
}

export default Clients;